import React, { FC } from 'react'
import ReactDOM from 'react-dom'
import { IModal } from '@globalActions'
import { Button } from '@/components/Button'
import { useModal } from '@/hooks/useModal'
import { Wrapper, ModalWrapper, Header, Content, Footer } from './style'

export const Modal: FC<IModal> = ({ message, header='Внимание!', variant = 'danger', onAgree }) => {
  const { hideModal } = useModal()

  const handleClick = () => {
    onAgree && onAgree()
    hideModal()
  }

  return message ? ReactDOM.createPortal(
    <Wrapper>
      <ModalWrapper>
        <Header>{header}</Header>
        <Content>{message}</Content>
        <Footer>
          {onAgree
            ? <>
              <Button onClick={handleClick} color='green'>Ок</Button>
              <Button onClick={hideModal} color='red'>Отмена</Button>
            </>

            : <Button onClick={hideModal} color='blue'>Ок</Button>
          }
        </Footer>
      </ModalWrapper>
    </Wrapper>,
    document.getElementsByTagName('body')[0]
  ) : null
}